export default (title, description) => `<div class='report-sub-section'>
<p><b><u>${title || 'About this section'}</u></b></p>
<p>${description || 'description...'}</p>
</div>`;
